import React from "react";
import { PropTypes } from "prop-types";
import { Container, Tab, Tabs } from "react-bootstrap";
import Page from "../common/Page";
import EmployeeByMonthReport from "./EmployeeByMonthReport";
import EmployeeYtdReport from "./EmployeeYtdReport";
import SubAccountsByMonthReport from "./SubAccountsByMonthReport";
import SubAccountsYtdReport from "./SubAccountsYtdReport";
import CashOutRequestByMonthReport from "./CashOutRequestByMonthReport";

function ReportsPage(props) {
  return (
    <Page pageTitle="Reports">
      <Container fluid>
        <Tabs justify variant="tabs">
          <Tab eventKey="allEmpByMonth" title="Employees By Month">
            <EmployeeByMonthReport isManger={props.isManager} />
          </Tab>
          <Tab eventKey="allEmpYtd" title="Employees YTD">
            <EmployeeYtdReport isManger={props.isManager} />
          </Tab>
          <Tab eventKey="allSubAcctByMonth" title="Subaccounts By Month">
            <SubAccountsByMonthReport isManger={props.isManager} />
          </Tab>
          <Tab eventKey="AllSubAcctYtd" title="Subaccounts YTD">
            <SubAccountsYtdReport isManger={props.isManager} />
          </Tab>
          <Tab eventKey="CashOutReqByMonth" title="Cash Requests By Month">
            <CashOutRequestByMonthReport isManger={props.isManager} />
          </Tab>
        </Tabs>
      </Container>
    </Page>
  );
}

ReportsPage.propTypes = {
  isManager: PropTypes.bool,
};

export default ReportsPage;
